/**
 * Checkbox multi-select helpers for Observer scope dropdowns.
 */

export const OBSERVER_SELECT_ALL_VALUE = '__observer_select_all__';

export interface ObserverSelectOption {
  value: string;
  label: string;
}

export function withSelectAllOption(
  options: ObserverSelectOption[],
  selectAllLabel = 'Select All',
): ObserverSelectOption[] {
  return [{ value: OBSERVER_SELECT_ALL_VALUE, label: selectAllLabel }, ...options];
}

export function isAllObserverOptionsSelected(
  allValues: string[],
  selected: string[],
): boolean {
  return (
    allValues.length > 0 && allValues.every((value) => selected.includes(value))
  );
}

export function toggleSelectAllValues(
  allValues: string[],
  selected: string[],
): string[] {
  if (isAllObserverOptionsSelected(allValues, selected)) {
    return [];
  }
  return [...allValues];
}

export function stripSelectAllValue(values: string[]): string[] {
  return values.filter((value) => value !== OBSERVER_SELECT_ALL_VALUE);
}

export function resolveObserverMultiSelectChange(
  nextValues: string[],
  allValues: string[],
  clickedValue?: string,
): string[] {
  if (clickedValue === OBSERVER_SELECT_ALL_VALUE) {
    const withoutSelectAll = stripSelectAllValue(nextValues);
    return toggleSelectAllValues(allValues, withoutSelectAll);
  }
  return stripSelectAllValue(nextValues);
}

export function buildObserverMultiSelectLabel(
  selected: string[],
  allValues: string[],
  singularLabel: string,
  pluralLabel: string,
  allLabel: string,
  noneLabel: string,
): string {
  const valid = selected.filter((value) => allValues.includes(value));
  if (valid.length === 0) {
    return noneLabel;
  }
  if (isAllObserverOptionsSelected(allValues, valid)) {
    return allLabel;
  }
  if (valid.length === 1) {
    return valid[0];
  }
  return `${valid.length} ${pluralLabel}`;
}
